import styled from '@emotion/styled';

export const Container = styled.div`
	position: relative;
	display: inline-flex;
`;

export const DropdownButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: ${(props) => props.theme.scale.space2xs};
	padding: 0.65rem 1rem 0.65rem 1.2rem;
	border: ${(props) => props.theme.ui.chip.border};
	border-radius: ${(props) => props.theme.ui.chip.radius};
	background: rgba(255, 255, 255, 0.92);
	box-shadow: ${(props) => props.theme.ui.chip.shadow};
	backdrop-filter: blur(10px);
	cursor: pointer;
	transition:
		border-color ${(props) => props.theme.effects.transitionFast},
		box-shadow ${(props) => props.theme.effects.transitionFast};

	&:hover {
		border-color: rgba(18, 83, 158, 0.24);
	}

	&:focus-visible {
		outline: none;
		box-shadow: 0 0 0 2px ${(props) => props.theme.ui.interactive.focusRing};
	}

	@media screen and (max-width: 1180px) {
		padding: 0.5rem 0.8rem 0.5rem 1rem;
	}
`;

export const Label = styled.span`
	color: ${(props) => props.theme.ui.text.muted};
	font-size: ${(props) => props.theme.ui.chip.fontSize};
	font-weight: ${(props) => props.theme.ui.chip.fontWeight};
	line-height: 1;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	flex-shrink: 0;
`;

export const CurrentValue = styled.span`
	color: ${(props) => props.theme.ui.text.primary};
	font-size: ${(props) => props.theme.ui.chip.fontSize};
	font-weight: ${(props) => props.theme.ui.chip.fontWeight};
	line-height: 1;
	white-space: nowrap;
`;

export const ArrowIcon = styled.span<{ isOpen: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: ${(props) => props.theme.ui.text.muted};
	transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform ${(props) => props.theme.effects.transitionFast};
	flex-shrink: 0;
`;

export const MenuList = styled.div`
	position: absolute;
	top: calc(100% + ${(props) => props.theme.scale.space2xs});
	right: 0;
	min-width: 100%;
	padding: 0.6rem;
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.ui.chip.radius};
	background: ${(props) => props.theme.ui.surface.page};
	box-shadow: ${(props) => props.theme.effects.shadowMd};
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.space3xs};
	z-index: 20;
`;

export const MenuItem = styled.button<{ active: boolean }>`
	border: none;
	background: ${(props) => (props.active ? props.theme.ui.interactive.primary : 'transparent')};
	padding: 0.9rem 1rem;
	border-radius: ${(props) => props.theme.effects.radiusMd};
	color: ${(props) => (props.active ? props.theme.ui.text.inverse : props.theme.ui.text.secondary)};
	font-size: ${(props) => props.theme.ui.chip.fontSize};
	font-weight: ${(props) => props.theme.ui.chip.fontWeight};
	line-height: 1;
	white-space: nowrap;
	text-align: left;
	cursor: pointer;
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		color ${(props) => props.theme.effects.transitionFast};

	&:hover {
		background: ${(props) => (props.active ? props.theme.ui.interactive.primary : props.theme.ui.interactive.hoverWash)};
	}

	&:focus-visible {
		outline: none;
		box-shadow: 0 0 0 2px ${(props) => props.theme.ui.interactive.focusRing};
	}
`;
